import React from "react";
import { NavLink } from "react-router-dom";
import { customersIconActive, billingIcon, invoiceIcon, profileIconActive, customersIcon, profileIcon, invoiceIconActive, billingIconActive, plansIcon, plansIconActive } from "../../constants/Images";


const LeftnavItem = ({to, activeIcon, inactiveIcon, title, exact}) => {
  const exactAttr = exact ? {} : { exact: true };
  return (
    <>
      <NavLink to={to} {...exactAttr} className="leftnavmenu__item" activeClassName="leftnavmenu__item--active">
          <img
            src={activeIcon}
            alt=""
            className="leftnavmenu__item__icon leftnavmenu__item__icon--inactive"
          />
          <img
            src={inactiveIcon}
            alt=""
            className="leftnavmenu__item__icon leftnavmenu__item__icon--active"
          />
          <span className="leftnavmenu__item__title">{title}</span>
      </NavLink>
    </>
  )
}

export default function Leftnav() {
  return (
    <div className="admin-wrapper-leftsection">
      <div className="leftnavmenu">
        <LeftnavItem to="/plans" activeIcon={plansIcon} inactiveIcon={plansIconActive} title="Plans" />
        <LeftnavItem to="/customers" activeIcon={customersIcon} inactiveIcon={customersIconActive} title="Customers" />
        <LeftnavItem to="/invoices" activeIcon={invoiceIcon} inactiveIcon={invoiceIconActive} title="Invoice" />
        <LeftnavItem to="/" activeIcon={profileIcon} inactiveIcon={profileIconActive} title="Profile" />
      </div>
    </div>
  );
}
